// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TQAcB16Lg8Eug7D6{height:100%;width:100%}.TQAcB16Lg8Eug7D6 .Fq2NFyU_6sG6dtzC{width:100%}.TQAcB16Lg8Eug7D6 .Fq2NFyU_6sG6dtzC .h74HkhqStHUgqYjU{display:flex;justify-content:space-between}.TQAcB16Lg8Eug7D6 .Fq2NFyU_6sG6dtzC .P6H_t3oVTiMqJwDg{padding-left:16px}.TQAcB16Lg8Eug7D6 .Fq2NFyU_6sG6dtzC .Tx9xeqYx4wHbYpmr{padding-right:8px;color:var(--py-neutral-0)}.TQAcB16Lg8Eug7D6 .DiAWDcHl9LMqXxdo{width:100%}.TQAcB16Lg8Eug7D6 .o9cLotzE8oEeJbUw{height:24px;font-weight:600;font-size:12px;line-height:16px;border-radius:50px;min-width:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"QueryBuilder": `TQAcB16Lg8Eug7D6`,
	"queries": `Fq2NFyU_6sG6dtzC`,
	"header": `h74HkhqStHUgqYjU`,
	"radioButtons": `P6H_t3oVTiMqJwDg`,
	"orButtonText": `Tx9xeqYx4wHbYpmr`,
	"addConditionButton": `DiAWDcHl9LMqXxdo`,
	"orButton": `o9cLotzE8oEeJbUw`
};
export default ___CSS_LOADER_EXPORT___;
